import { IDataSource } from 'core-components/types/ICrudHelpers'

export const jbpBasicInfoDataSource: IDataSource = {
  formId: '1091',
  code: 'jbp-basicinfo-1091',
}
